import { call, put, takeEvery } from 'redux-saga/effects';
import { changeBikeModel } from '../../../Bike_model_update/requests/change_bike_model_request';
import { changeBikeModelListRequestSuccess, changeBikeModelListRequestFailure } from '../../../Bike_model_update/redux/actions/change_bike_model.actions';
import { CHANGE_BIKE_MODEL_LIST_REQUEST } from '../constants/bike_model.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* changeBikeModelListRequest({ model_id, key, value }) {
    const { result, status } = yield call(changeBikeModel, model_id, key, value);
    if (status) {
        yield put(changeBikeModelListRequestSuccess(key, result));
        message_success('Bike model updated successfully!');
    } else if (result === 'warn') {
        yield put(changeBikeModelListRequestFailure('Permission Denied'));
        message_error('Permission Denied');
    } else {
        yield put(changeBikeModelListRequestFailure('Something gone wrong!'));
        message_error('Something gone wrong!');
    }
}

export default function* changeBikeModelListSaga() {
    yield takeEvery(CHANGE_BIKE_MODEL_LIST_REQUEST, changeBikeModelListRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/change_bike_model_list.saga.js